'use client';


import { useSession } from "next-auth/react"; // Import useSession
import Image from "next/image";
import { useTranslations } from 'next-intl';


import { useLocale } from "next-intl";

const TextBlock = () => {
const te = useTranslations('tophero');
  const t = useTranslations('AboutPage');
  const { data: session, status } = useSession(); // Get session and status
   const l = useLocale();
 
  function images() {
    return l == "ar" ? "/logo-white/شعار-بادليف-أبيض.webp" :
      (l == "de" ? "/logo-white/padlev-logo-weiss.webp" :
        (l == "es" ? "/logo-white/logo-padlev-blanco.webp" :
          (l == "fr" ? "/logo-white/logo-padlev-blanc.webp" :
            (l == "it" ? "/logo-white/logo-padlev-bianco.webp" :
              (l == "nl" ? "/logo-white/padlev-logo-wit.webp" :
                (l == "pt" ? "/logo-white/logo-padlev-branco.webp" :
                  (l == "ru" ? "/logo-white/padlev-logo-belyy.webp" :
                    (l == "sv" ? "/logo-white/padlev-logo-vit.webp" :
                      "/logo-white/padlev-logo-white.webp"
                    )
                  )
                )
              )
            )
          )
        )
      );
  }

  return (
  <>
  <hr className="w-full border-t border-yel " />
    <section className="text-block bg-black text-white ">
     
      <div className="container ">
        <div className="text-block-col ">
          
            <h3 className="text-2xl md:text-3xl lg:text-6xl font-extrabold uppercase ">{t('section-4-title')}</h3>
          
          <div className="text-block-logo">
           <div className="relative h-16 w-40 ">
                         <Image
                           src={images()} // or "/logo.webp" if using an webp
                           alt={te('logo-padlev')}
                           fill
                           sizes='100%'
                           style={{ objectFit: 'contain' }} // Maintain aspect ratio
                           priority // Ensures it loads faster
                         />
                       </div>
          </div>
        </div>
        <div className="text-block-col">
          <div className="text-block-copy">
           
              <p className="bodyCopy sm">
                {t('section-4-p1')}
              </p>
           
          </div>
          <div className="text-block-copy">
           
              <p className="bodyCopy sm">
                {t('section-4-p2')}
              </p>
            
          </div>
        </div>
      </div>
    </section>
      <hr className="w-full border-t border-yel " />
    </>
  );
};

export default TextBlock;
